import {updateUrlOnDateSwitchChange, updateUrlParams} from "../../../utils";
import {useSearchParams} from "react-router";
import {CustomerFilterAutoComplete, FieldDateSwitch2, FieldDateSwitchValue} from "../../ui";
import {FieldMultiSelect} from "@kroschke/react-ui";
import {convertDocumentType, displayShipmentProcessType, displayShipmentType} from "../../../api";
import {DocumentTypeDto} from "../../../api/sea";
import {useEffect, useState} from "react";
import {fmsOverviewStore, pageQueryStore} from "../../../store";
import {ShipmentProcessTypeDto, ShipmentTypeDto} from "../../../api/fms";
import {fmsCustomerStore} from "../../../store/fms/FmsCustomerStore";


const documentDropDownOptions = Object.keys(DocumentTypeDto).map(e => ({
    value: e,
    label: convertDocumentType(e as DocumentTypeDto)
}))

const processDropDownOptions = Object.keys(ShipmentProcessTypeDto).map(e => ({
    value: e,
    label: displayShipmentProcessType(e as ShipmentProcessTypeDto)
}))

const shipmentTypeDropDownOptions = Object.keys(ShipmentTypeDto).map(e => ({
    value: e,
    label: displayShipmentType(e as ShipmentTypeDto)
}))

function FmsItemFilterbar() {
    const [searchParams, setSearchParams] = useSearchParams()

    const type = (searchParams.getAll('documentType') || [])
    const process = (searchParams.getAll('process') || [])
    const shipment = (searchParams.getAll('shipmentType') || [])

    const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
    const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
    const queryS = searchParams.get('q') || undefined
    const customerIdS = searchParams.get('customerId') || undefined
    const sortByS = searchParams.get('sortBy') || undefined

    const [from, setFrom] = useState<FieldDateSwitchValue | undefined>(fromS ? {
        absolute: searchParams.get('fromAbsolute') || undefined,
        relative: searchParams.get('fromRelative') || undefined,
    } : undefined)
    const [to, setTo] = useState<FieldDateSwitchValue | undefined>(toS ? {
        absolute: searchParams.get('toAbsolute') || undefined,
        relative: searchParams.get('toRelative') || undefined,
    } : undefined)
    const [docType, setDocType] = useState(type)
    const [processType, setProcessType] = useState(process)
    const [shipmentType, setShipmentType] = useState(shipment)
    const [, setSortBy] = useState(sortByS)

    useEffect(() => {
        const type = (searchParams.getAll('documentType') || [])
        const process = (searchParams.getAll('process') || [])
        const shipment = (searchParams.getAll('shipmentType') || [])

        const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
        const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
        const sortByS = (searchParams.get('sortBy') || undefined)
        setFrom(fromS ? {
            absolute: searchParams.get('fromAbsolute') || undefined,
            relative: searchParams.get('fromRelative') || undefined,
        } : undefined)
        setTo(toS ? {
            absolute: searchParams.get('toAbsolute') || undefined,
            relative: searchParams.get('toRelative') || undefined,
        } : undefined)
        setDocType(type)
        setProcessType(process)
        setShipmentType(shipment)
        setSortBy(sortByS)
    }, [
        searchParams,
        setFrom,
        setTo,
        setDocType,
        setProcessType,
        setSortBy,
    ])

    const hasFilter = Boolean(fromS)
        || Boolean(toS)
        || Boolean(docType.length)
        || Boolean(shipmentType.length)
        || Boolean(processType.length)
        || Boolean(queryS)
        || Boolean(customerIdS)
        || Boolean(sortByS)

    return <div style={{
        display: 'flex',
        zoom: '85%',
        alignItems: 'flex-start',
        zIndex: 1
    }}>
        <div style={{
            minWidth: '2em',
            maxWidth: '12em',
            marginRight: '1em'
        }}>
            <CustomerFilterAutoComplete
                items={fmsCustomerStore.items}
                search={fmsCustomerStore.search}
                param={'customerId'}/>
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Von"}
                value={from}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'from', searchParams, setSearchParams)
                    setFrom(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Bis"}
                value={to}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'to', searchParams, setSearchParams)
                    setTo(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '10em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Dokumente"}
                options={documentDropDownOptions}
                required={true}
                value={docType}
                onChange={value => {
                    updateUrlParams({val: [{param: 'documentType', value}], setSearchParams, searchParams})
                    setDocType(value)
                }}
            />
        </div>
        <div style={{
            minWidth: '12em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Versandart"}
                options={shipmentTypeDropDownOptions}
                value={shipmentType}
                onChange={value => {
                    updateUrlParams({val: [{param: 'shipmentType', value}], setSearchParams, searchParams})
                    setShipmentType(value)
                }}
            />
        </div>
        <div style={{
            minWidth: '15em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Prozess"}
                options={processDropDownOptions}
                value={processType}
                onChange={value => {
                    updateUrlParams({val: [{param: 'process', value}], setSearchParams, searchParams})
                    setProcessType(value)
                }}
            />
        </div>
        {<div style={{
            minWidth: '10em',
            maxWidth: '20em',
        }}>
            <button
                className={'button is-primary is-rounded'}
                disabled={!hasFilter}
                onClick={() => {
                    setFrom(undefined)
                    setTo(undefined)
                    setProcessType([])
                    setShipmentType([])
                    setDocType([])
                    Array.from(searchParams.keys()).forEach(key => {
                        searchParams.delete(key)
                    })
                    fmsOverviewStore.sortBy = undefined
                    setSearchParams(searchParams)
                    pageQueryStore.clear('fms')
                }}
                style={{
                    marginTop: '0.3em'
                }}
            >
                <span className={`icon is-small`}>
                    <span className="material-symbols-outlined">filter_list_off</span>
                </span>
                <span>Zurücksetzen</span>
            </button>
        </div>}
    </div>
}

export {
    FmsItemFilterbar
}
